var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.content)?_c('div',{staticClass:"space-y-12"},_vm._l((_vm.content),function(component,i){return _c(_vm.componentLoader(component),{key:i,tag:"component",attrs:{"data":component}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }